class Loading {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const icon = document.querySelector('.c-loading-wrap__icon')
    const timeLine = gsap.timeline()
      .fromTo('.js-loading-wrap',0.6, { opacity: '1' }, { opacity: '0',ease: 'power2.inOut' }, 0.5)
      .fromTo('.js-loading-bg',1, {scale: '2',y:'0' }, { scale: '1', y:'100%' ,ease: 'power2.inOut' }, '<')
  }
}